import { Component } from '@angular/core';

@Component({
    selector: 'app-utf-syncing-information',
    templateUrl: './utf-syncing-information.component.html',
    styleUrls: ['./utf-syncing-information.component.scss'],
    standalone: false
})
export class UtfSyncingInformationComponent {


}
